import { MDBProgress, MDBProgressBar, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'

export const BarComponent = ({Counter, setCounter, Progress, TitleState, ProgressShow }) => {
  return (
    <MDBRow className="d-flex justify-content-center">
        <MDBRow className="col-12">
          {ProgressShow ? (
          <MDBProgress className="mb-3">
            {Progress === 0 ? null : (
              <MDBProgressBar
              bgColor={Progress === 100 ? 'success' : 'warning'} 
              width={Progress} 
              valuemin={0} 
              valuemax={100} />
            )}
          </MDBProgress>
          ): null}
        </MDBRow>

        {Counter <= 1 ? (
          <div className=" col-3 col-lg-2"></div>
        ) : (
          <div className="col-3 col-lg-2">
            <button
              className="btn btn-primary mb-1 col-12"
              onClick={() => 
                Counter > 1 ? setCounter(Counter - 1) : null
              }
            >
              {`<`}
            </button>
          </div>
        )}

        {TitleState === "" ? null : (
          <div className=" col-6 col-lg-5">
            <button
              className="btn btn-primary mb-1 col-12"
            >
              {TitleState === "" ? null : TitleState}
            </button>
          </div>
          )}

        {Counter >= 2 || TitleState === "" ? (
          <div className=" col-3 col-lg-2"> </div>
        ) : (
          <div className=" col-3 col-lg-2">
            <button
              className="btn btn-primary mb-1 col-12"
              onClick={() => 
                Counter < 3 ? (setCounter(Counter + 1)) : null
              }
            >
              {`>`}
            </button>
          </div>
        )}
      </MDBRow>
  )
}
